export default {
  'hirer': 'Hirer',
  'hired': 'Hired',
  'referrals': 'Referrals',
  'shareUrReferral': 'Share your referral link',
  'referralLink': 'Referral link',
  'copyToClipboard': 'Copy to clipboard',
  'shareUrReferralDesc': 'Share your referral link for this job on social media or copy it to share however you want. If somebody uses your referral then we’ll credit you.'
}



// WEBPACK FOOTER //
// ./src/i18n/en/referrals.js